import {
  authHeader,
  authHeaderFormData,
  authHeaderNoToken,
  handleResponse
} from "../helper/auth-header";

export default class ProductService {
  ControllerName = "Product";

  // get Products
  async GetProduct(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(obj)
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetProduct`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async CreateUpdateProduct(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeaderFormData(),
      body: obj
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/CreateUpdateProduct`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async SaveCartonIds(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(obj)
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/SaveCartonIds`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async UpdateIds(type, value) {
    const requestOptions = {
      method: "GET",
      headers: authHeader()
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/UpdateIds/${type},${value}`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async GetIds() {
    const requestOptions = {
      method: "GET",
      headers: authHeaderFormData()
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetIds`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async QRScratchTracking(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeaderNoToken(),
      body: JSON.stringify(obj)
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/QRScratchTracking`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async QRTracking(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeaderNoToken(),
      body: JSON.stringify(obj)
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/QRTracking`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }
}
